import React from "react";
import {Field, ErrorMessage} from "formik";
import TextError from "./TextErrorComponent";
import './form.scss'

//The component Formik for text areas
function Textarea (props) {
    const { label, name, ...rest } = props;

    return (
        <div className="formControl">
            <label htmlFor={name} className="label">{label}</label>
            <Field as="textarea" id={name} name={name} {...rest} className="textArea"/>
            <ErrorMessage name={name} component={TextError}/>
        </div>
    )
}
export default Textarea;
